var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/text-truncate-macro.j2"] = require( "macros/text-truncate-macro.j2" );
dependencies["product-condition.j2"] = require( "product-condition.j2" );
dependencies["product-store-availability.j2"] = require( "product-store-availability.j2" );
dependencies["product-contents.j2"] = require( "product-contents.j2" );
dependencies["product-shipping-returns.j2"] = require( "product-shipping-returns.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-details.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/text-truncate-macro.j2", false, "product/templates/product-details.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("textTruncate", t_1);
var t_4;
t_4 = (lineno = 2, colno = 21, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.product.isVintage",false]));
frame.set("isVintage", t_4, true);
if(frame.topLevel) {
context.setVariable("isVintage", t_4);
}
if(frame.topLevel) {
context.addExport("isVintage", t_4);
}
output += "\n";
var t_5;
t_5 = (lineno = 3, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.product.isMarketPlace",false]));
frame.set("isMarketplace", t_5, true);
if(frame.topLevel) {
context.setVariable("isMarketplace", t_5);
}
if(frame.topLevel) {
context.addExport("isMarketplace", t_5);
}
output += "\n";
var t_6;
t_6 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"isSoldOut") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productIsUnavailable");
frame.set("isProductUnavailable", t_6, true);
if(frame.topLevel) {
context.setVariable("isProductUnavailable", t_6);
}
if(frame.topLevel) {
context.addExport("isProductUnavailable", t_6);
}
output += "\n";
var t_7;
t_7 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen") && runtime.contextOrFrameLookup(context, frame, "isProductUnavailable");
frame.set("quickshopIsOpenAndProductUnavailable", t_7, true);
if(frame.topLevel) {
context.setVariable("quickshopIsOpenAndProductUnavailable", t_7);
}
if(frame.topLevel) {
context.addExport("quickshopIsOpenAndProductUnavailable", t_7);
}
output += "\n";
var t_8;
t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen") || runtime.contextOrFrameLookup(context, frame, "isProductUnavailable");
frame.set("quickshopIsOpenOrProductUnavailable", t_8, true);
if(frame.topLevel) {
context.setVariable("quickshopIsOpenOrProductUnavailable", t_8);
}
if(frame.topLevel) {
context.addExport("quickshopIsOpenOrProductUnavailable", t_8);
}
output += "\n";
var t_9;
t_9 = (lineno = 7, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["product.configs.storePickupEnabled",false])) && !runtime.contextOrFrameLookup(context, frame, "quickshopIsOpenOrProductUnavailable");
frame.set("showStoreAvailability", t_9, true);
if(frame.topLevel) {
context.setVariable("showStoreAvailability", t_9);
}
if(frame.topLevel) {
context.addExport("showStoreAvailability", t_9);
}
output += "\n";
var t_10;
t_10 = !runtime.contextOrFrameLookup(context, frame, "quickshopIsOpenAndProductUnavailable") && !runtime.contextOrFrameLookup(context, frame, "forFamilyProduct") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"product")),"isEgiftCard") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"hideShippingReturns");
frame.set("showShippingAndReturns", t_10, true);
if(frame.topLevel) {
context.setVariable("showShippingAndReturns", t_10);
}
if(frame.topLevel) {
context.addExport("showShippingAndReturns", t_10);
}
output += "\n";
var t_11;
t_11 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"selectedSku")),"sku") && !runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productDetails")),"isFlatRate") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"productDetails")),"shipRestriction");
frame.set("hasRestrictions", t_11, true);
if(frame.topLevel) {
context.setVariable("hasRestrictions", t_11);
}
if(frame.topLevel) {
context.addExport("hasRestrictions", t_11);
}
output += "\n\n";
var t_12;
t_12 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"longDescription") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"additionalDescription") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"dimensions") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"modelNotes");
frame.set("showProductDetails", t_12, true);
if(frame.topLevel) {
context.setVariable("showProductDetails", t_12);
}
if(frame.topLevel) {
context.addExport("showProductDetails", t_12);
}
output += "\n\n";
var t_13;
t_13 = env.getFilter("length").call(context, (lineno = 17, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["productDetails.contents",[]]))) > 0;
frame.set("showProductContents", t_13, true);
if(frame.topLevel) {
context.setVariable("showProductContents", t_13);
}
if(frame.topLevel) {
context.addExport("showProductContents", t_13);
}
output += "\n\n";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"hideDetails")) {
output += "\n\n    <div class=\"s-product-details c-product-details js-product-details\" data-qa-product-details>\n\n        <div class=\"o-accordion js-accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "isVintage") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "quickshop")),"isOpen")) {
output += "\n\n                ";
output += "\n                <div class=\"";
if(!runtime.contextOrFrameLookup(context, frame, "showShippingAndReturns") && !runtime.contextOrFrameLookup(context, frame, "hasRestrictions")) {
output += "s-last-tab ";
;
}
output += "o-accordion__tabset js-accordion-tabset\" data-accordion-tab-name=\"condition\">\n\n                    ";
env.getTemplate("product-condition.j2", false, "product/templates/product-details.j2", null, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
output += "\n\n                </div>\n\n            ";
})});
}
output += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "showStoreAvailability")) {
output += "\n                ";
output += "\n                <div class=\"";
if(!runtime.contextOrFrameLookup(context, frame, "showProductDetails") && !runtime.contextOrFrameLookup(context, frame, "showShippingAndReturns")) {
output += "s-last-tab ";
;
}
output += "o-accordion__tabset js-accordion-tabset js-expand-all-sizes\" data-accordion-tab-name=\"store availability\">\n                    ";
env.getTemplate("product-store-availability.j2", false, "product/templates/product-details.j2", null, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
t_18.render(context.getVariables(), frame, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
output += t_19
output += "\n                </div>\n            ";
})});
}
output += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "showProductDetails")) {
output += "\n\n                <div class=\"";
if(!runtime.contextOrFrameLookup(context, frame, "showShippingAndReturns") && !runtime.contextOrFrameLookup(context, frame, "hasRestrictions") && !runtime.contextOrFrameLookup(context, frame, "showProductContents")) {
output += "s-last-tab ";
;
}
output += "o-accordion__tabset js-accordion-tabset\" data-accordion-tab-name=\"details\">\n\n                    ";
output += "\n                    <div class=\"o-row\">\n\n                        <div class=\"o-column o-extra-small--12\">\n\n                            <a\n                                href=\"#product_description__panel\"\n                                id=\"product_description__tab\"\n                                class=\"o-accordion__tab c-product-details__tab js-accordion-tab has-mouse-click-focus-disabled\"\n                                aria-selected=\"true\"\n                                aria-controls=\"product_description__panel\"\n                                aria-expanded=\"true\"\n                                role=\"tab\"\n                                data-accordion-title=\"product description\"\n                                >\n\n                                <h3 class=\"o-accordion__label c-product-details__label\" data-qa-details-accordion>\n                                    ";
output += runtime.suppressValue((lineno = 64, colno = 38, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_details-label",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                                </h3>\n\n                                <span class=\"o-accordion__control c-product-details__collapse\" title=\"collapse\"></span>\n\n                            </a>\n\n                        </div>\n\n                    </div>\n\n                    ";
output += "\n                    <div id=\"product_description__panel\" class=\" s-cms o-accordion__panel js-accordion-panel c-product-details__section c-product-details__section--pdp\" aria-labelledby=\"product_description__tab\" aria-hidden=\"false\" role=\"tabpanel\" data-qa-product-description>\n\n                        <div class=\"o-row\">\n\n                            <div class=\"o-column o-extra-small--12\">\n\n                                <div class=\"u-global-p\">\n\n                                    ";
output += "\n                                    <p>\n                                        ";
output += runtime.suppressValue((lineno = 86, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_details-style-number",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += " <span data-qa-product-description-sku>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "product")),"styleNumber"), env.opts.autoescape);
output += "</span> ; ";
output += runtime.suppressValue((lineno = 86, colno = 157, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_details-color-code",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += " <span data-qa-product-description-color>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"colorCode"), env.opts.autoescape);
output += "</span>\n                                    </p>\n\n                                    ";
output += "\n                                    ";
output += runtime.suppressValue((lineno = 90, colno = 62, runtime.callWrap(runtime.memberLookup((t_1),"truncateText"), "textTruncate[\"truncateText\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"longDescription"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"truncateCharacterLimit")),"product_description"),"productDetail","description"])), env.opts.autoescape);
output += "\n\n                                </div>\n\n                            </div>\n\n                        </div>\n\n                        ";
if(runtime.contextOrFrameLookup(context, frame, "isMarketplace")) {
output += "\n\n                            <div class=\"o-row\">\n\n                                <div class=\"o-column o-extra-small--12\">\n\n                                    <span class=\"c-product-details__marketplace-disclaimer\" data-qa-marketplace-disclaimer>\n\n                                        ";
output += runtime.suppressValue((lineno = 106, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["marketplace_product-description-disclaimer"])), env.opts.autoescape);
output += "\n\n                                    </span>\n\n                                </div>\n\n                            </div>\n\n                        ";
;
}
output += "\n\n                        <div class=\"o-row\">\n\n                            ";
output += "\n                            <div class=\"o-column o-extra-small--12 o-large--6\">\n\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"additionalDescription")) {
output += "\n\n                                    <div class=\"c-product-details__additional-description\">\n                                        ";
output += runtime.suppressValue(env.getFilter("markdown").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"additionalDescription")), env.opts.autoescape);
output += "\n                                    </div>\n\n                                ";
;
}
output += "\n\n                            </div>\n\n                            <div class=\"o-column o-extra-small--12 o-large--6\">\n\n                                ";
output += "\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"dimensions")) {
output += "\n\n                                    <h3 class=\"u-global-h3\">\n                                        ";
output += runtime.suppressValue((lineno = 137, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_details-dimensions",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                                    </h3>\n\n                                    <div class=\"c-product-details__notes\">\n                                        ";
output += runtime.suppressValue((lineno = 141, colno = 66, runtime.callWrap(runtime.memberLookup((t_1),"truncateText"), "textTruncate[\"truncateText\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"dimensions"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"truncateCharacterLimit")),"product_description"),"productDetail"])), env.opts.autoescape);
output += "\n                                    </div>\n                                ";
;
}
output += "\n\n                                ";
output += "\n                                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"modelNotes") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"modelNotes") != "\n") {
output += "\n\n                                    <h3 class=\"u-global-h3\">\n                                        ";
output += runtime.suppressValue((lineno = 149, colno = 42, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_details-model-notes",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                                    </h3>\n\n                                    <div class=\"c-product-details__notes\">\n                                        ";
output += runtime.suppressValue((lineno = 153, colno = 66, runtime.callWrap(runtime.memberLookup((t_1),"truncateText"), "textTruncate[\"truncateText\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"modelNotes"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"truncateCharacterLimit")),"product_description"),"productDetail"])), env.opts.autoescape);
output += "\n                                    </div>\n\n                                ";
;
}
output += "\n\n                            </div>\n\n                        </div>\n\n                        ";
output += "\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"brand") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"brandDescription")) {
output += "\n\n                            <div class=\"o-row\">\n\n                                <div class=\"o-column o-extra-small--12\">\n\n                                    <h3 class=\"u-global-h3\"> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"brand"), env.opts.autoescape);
output += " </h3>\n\n                                    <div class=\"c-product-details__notes\"> ";
output += runtime.suppressValue(env.getFilter("markdown").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"brandDescription")), env.opts.autoescape);
output += " </div>\n\n                                </div>\n\n                            </div>\n\n                        ";
;
}
output += "\n\n                        ";
output += "\n                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"care") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"origin")) {
output += "\n\n                            <div class=\"o-row\">\n\n                                <div class=\"o-column o-extra-small--12\">\n\n                                    <h3 class=\"u-global-h3\"> ";
output += runtime.suppressValue((lineno = 186, colno = 63, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_details-care-import"])), env.opts.autoescape);
output += " </h3>\n\n                                    <p>\n                                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"care")) {
output += "\n\n                                            ";
output += runtime.suppressValue(env.getFilter("markdown").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"care"),"productDetail"), env.opts.autoescape);
output += "\n\n                                        ";
;
}
output += "\n\n                                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"origin")) {
output += "\n\n                                            ";
output += runtime.suppressValue(env.getFilter("markdown").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"origin"),"productDetail"), env.opts.autoescape);
output += "\n\n                                        ";
;
}
output += "\n                                    </p>\n\n                                </div>\n\n                            </div>\n\n                        ";
;
}
output += "\n\n                        ";
var t_22;
t_22 = (lineno = 208, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["productDetails.measurements",runtime.makeKeywordArgs({"default": []})]));
frame.set("measurements", t_22, true);
if(frame.topLevel) {
context.setVariable("measurements", t_22);
}
if(frame.topLevel) {
context.addExport("measurements", t_22);
}
output += "\n\n                        ";
output += "\n                        ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "measurements")) > 0) {
output += "\n\n                            <div class=\"o-row\">\n\n                                <div class=\"o-column o-extra-small--12\">\n\n                                    <h3>\n\n                                        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"sampleSize")) {
output += "\n\n                                            ";
output += runtime.suppressValue((lineno = 221, colno = 46, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_details-measurements-for-size",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += " ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "productDetails")),"sampleSize"), env.opts.autoescape);
output += "\n\n                                        ";
;
}
else {
output += "\n\n                                            ";
output += runtime.suppressValue((lineno = 225, colno = 46, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_details-measurements",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n\n                                        ";
;
}
output += "\n\n                                    </h3>\n\n                                    <ul>\n\n                                        ";
frame = frame.push();
var t_25 = runtime.contextOrFrameLookup(context, frame, "measurements");
if(t_25) {var t_24 = t_25.length;
for(var t_23=0; t_23 < t_25.length; t_23++) {
var t_26 = t_25[t_23];
frame.set("measurement", t_26);
frame.set("loop.index", t_23 + 1);
frame.set("loop.index0", t_23);
frame.set("loop.revindex", t_24 - t_23);
frame.set("loop.revindex0", t_24 - t_23 - 1);
frame.set("loop.first", t_23 === 0);
frame.set("loop.last", t_23 === t_24 - 1);
frame.set("loop.length", t_24);
output += "\n                                            <li>\n                                            ";
output += runtime.suppressValue(runtime.memberLookup((t_26),"measurementTitle"), env.opts.autoescape);
output += ":\n                                            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"language") == "en-US") {
output += "\n                                                ";
output += runtime.suppressValue(runtime.memberLookup((t_26),"us"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((lineno = 237, colno = 67, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_details-measurementUnits",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                                            ";
;
}
else {
output += "\n                                                ";
output += runtime.suppressValue(runtime.memberLookup((t_26),"metric"), env.opts.autoescape);
output += " ";
output += runtime.suppressValue((lineno = 239, colno = 71, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_details-measurementUnits",runtime.makeKeywordArgs({"state": runtime.contextOrFrameLookup(context, frame, "core")})])), env.opts.autoescape);
output += "\n                                            ";
;
}
output += "\n                                            </li>\n                                        ";
;
}
}
frame = frame.pop();
output += "\n\n                                    <ul>\n\n                                </div>\n\n                            </div>\n\n                        ";
;
}
output += "\n\n                    </div>\n\n                </div>\n\n            ";
;
}
output += "\n\n            ";
output += "\n            ";
if(runtime.contextOrFrameLookup(context, frame, "showProductContents") && env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "quickshop")) == 0) {
output += "\n\n                ";
env.getTemplate("product-contents.j2", false, "product/templates/product-details.j2", null, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_27.render(context.getVariables(), frame, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
output += t_28
output += "\n\n            ";
})});
}
output += "\n\n            ";
output += "\n            ";
if(runtime.contextOrFrameLookup(context, frame, "showShippingAndReturns")) {
output += "\n\n                ";
env.getTemplate("product-shipping-returns.j2", false, "product/templates/product-details.j2", null, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
t_31.render(context.getVariables(), frame, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
output += t_32
output += "\n\n            ";
})});
}
output += "\n\n        </div>\n\n    </div>\n\n";
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-details.j2"] , dependencies)